import { getDocumentElements, getScrollTop, getScrollLeft } from '../utils'

const [tablesLight, tableDark] = getDocumentElements([
    { className: 'tet-table-wrapper', getAllElements: true },
    { className: 'tet-table-wrapper--dark', getAllElements: true },
])

const init = () => {
    if (tablesLight || tableDark) {
        const isOverflow = () => {
            Array.from(tablesLight || tableDark).map(table => {
                const tableWrapperWidth = table.offsetWidth
                const childTableWidth = table.querySelector('.tet-table,.tet-table--dark')
                    .offsetWidth
                const tableWidth = table.offsetWidth

                if (tableWrapperWidth < childTableWidth) {
                    table.classList.add('table-overflow-right')
                } else {
                    table.classList.remove('table-overflow-right')
                }

                table.addEventListener('scroll', () => {
                    let scrollLeft = table.scrollLeft
                    let scrollEnd = table.scrollWidth
                    table.querySelector('.tet-table-gradient').style.right = `-${scrollLeft}px`

                    if (scrollLeft == scrollEnd - tableWidth) {
                        table.classList.remove('table-scroll-start')
                        table.classList.add('table-scroll')
                    }

                    if (scrollLeft < scrollEnd - tableWidth) {
                        table.classList.add('table-scroll-start')
                        table.classList.add('table-overflow-right')
                        table.classList.remove('table-scroll')
                    }
                })
            })
        }
        isOverflow()

        window.addEventListener('resize', () => {
            isOverflow()
        })

        Array.from(tablesLight || tableDark).map(table => {
            let div = document.createElement('div')
            div.setAttribute('class', 'tet-table-gradient')
            table.appendChild(div)
        })
    }
}

export { init }
